import { Link } from 'react-router-dom';

import { appConfig } from '../config/appConfig';

export const SUPPORT_WECHAT_IDS = ['revisionbrook', 'GemDiaryFamily'] as const;
export const SUPPORT_EMAIL = 'keliriji@163.com';
/** @deprecated use SUPPORT_WECHAT_IDS */
export const SUPPORT_WECHAT_ID = SUPPORT_WECHAT_IDS[0];

export function SupportDocument() {
  return (
    <article className="text-[15px] leading-7 text-[#2D3139]">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-extrabold tracking-tight text-ink">联系我们</h1>
        <p className="text-sm text-muted">{appConfig.appName} · 技术支持</p>
      </header>

      <div className="mb-6 rounded-md border-l-[3px] border-primary bg-[#EAF2FF] px-3.5 py-3 text-sm text-[#2D3139]">
        如需产品使用帮助、账号问题或功能反馈，请添加微信或发送邮件联系我们，我们将尽快与您联系。
      </div>

      <section className="mb-6 rounded-2xl border border-border bg-surface p-6 shadow-card">
        <h2 className="mb-3 text-base font-bold text-[#0B5CAB]">微信技术支持</h2>
        <p className="mb-4 text-muted">请搜索并添加以下微信号之一：</p>
        <div className="flex flex-col gap-3 sm:flex-row">
          {SUPPORT_WECHAT_IDS.map((id) => (
            <div
              key={id}
              className="inline-flex items-center gap-3 rounded-xl border border-primary/20 bg-[#EAF2FF] px-5 py-4"
            >
              <span className="text-sm font-medium text-muted">微信号</span>
              <code className="text-xl font-bold tracking-wide text-primary">{id}</code>
            </div>
          ))}
        </div>
        <p className="mt-4 text-sm text-muted">
          打开微信 → 添加朋友 → 搜索微信号 → 输入
          {' '}
          <strong className="text-ink">revisionbrook</strong>
          {' '}或{' '}
          <strong className="text-ink">GemDiaryFamily</strong>
          {' '}→ 发送好友申请。
        </p>
      </section>

      <section className="mb-6 rounded-2xl border border-border bg-surface p-6 shadow-card">
        <h2 className="mb-3 text-base font-bold text-[#0B5CAB]">电子邮箱</h2>
        <p className="mb-3 text-muted">也可发送邮件至：</p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex text-xl font-bold tracking-wide text-primary hover:underline"
        >
          {SUPPORT_EMAIL}
        </a>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">可咨询的内容</h2>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>账户注册、登录与密码相关问题</li>
          <li>素材上传、知识颗粒提取与关系图使用</li>
          <li>复习功能、学习设置与打印预览</li>
          <li>网站、iOS / Android 移动端及 iPad 平板端使用问题</li>
          <li>功能建议与问题反馈</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">其他说明</h2>
        <p className="mb-3">
          已登录用户也可在应用内通过「反馈」入口提交问题。隐私与数据相关问题请参阅
          <Link to="/privacy" className="text-primary hover:underline"> 隐私政策</Link>。
        </p>
        <p>技术支持工作时间：周一至周五 10:00–18:00（法定节假日除外）。非工作时间留言将在下一工作日回复。</p>
      </section>

      <p className="border-t border-border pt-6 text-center text-sm text-[#8A9CB8]">
        {appConfig.appName} · {appConfig.sitePublicUrl}
      </p>
    </article>
  );
}
